module.exports = __webpack_public_path__ + "img/ni.32e4d1fe.svg";